export default "__VITE_ASSET__DwlkQe$W__"